import React, {FC, Fragment} from 'react';
import messages from '../messages';
import {useMaterialForm} from './use-material-form';
import {useUpdateMaterialForm} from './use-material-update-form';
import Button from 'components/button';
import TextInput from 'components/text-input';
import {useTranslation} from 'react-i18next';
import {Alert, ModalBody, ModalFooter, ModalHeader, Row} from 'reactstrap';
import {Material} from 'types/materials';

interface Props {
  message?: string;
  onDismiss: () => void;
  store: boolean;
  material?: Material;
}

const MaterialModal: FC<Props> = props => {
  const {onDismiss, store, material} = props;
  const {params, validationErrors, isLoading, errorMessage, submit, setParams} =
    useMaterialForm(onDismiss);
  const {
    updateParams,
    updateValidationErrors,
    updateIsLoading,
    updateErrorMessage,
    updateSubmit,
    setUpdateParams,
  } = useUpdateMaterialForm(onDismiss, material);
  const {t} = useTranslation();

  return (
    <Fragment>
      <ModalHeader className="bg-primary" toggle={onDismiss}>
        <span className="text-light">{t(...messages.title())}</span>
      </ModalHeader>
      <ModalBody className="">
        <div>
          <Row>
            {material && (
              <div>
                <div className="mb-3">
                  <TextInput
                    label={t(...messages.nameFr())}
                    value={updateParams.name?.fr}
                    errors={validationErrors['name.fr']}
                    onChange={fr => {
                      setUpdateParams({
                        ...updateParams,
                        name: {
                          ...updateParams.name,
                          fr: fr,
                        },
                      });
                    }}
                  />
                </div>
                <div className="mb-3">
                  <TextInput
                    label={t(...messages.nameEn())}
                    value={updateParams.name?.en}
                    errors={validationErrors['name.en']}
                    onChange={en => {
                      setUpdateParams({
                        ...updateParams,
                        name: {
                          ...updateParams.name,
                          en: en,
                        },
                      });
                    }}
                  />
                </div>
              </div>
            )}
            {!material && (
              <div>
                <div className="mb-3">
                  <TextInput
                    label={t(...messages.nameFr())}
                    value={params.name.fr}
                    errors={validationErrors['name.fr']}
                    onChange={fr => {
                      setParams({
                        ...params,
                        name: {
                          ...params.name,
                          fr: fr,
                        },
                      });
                    }}
                  />
                </div>
                <div className="mb-3">
                  <TextInput
                    label={t(...messages.nameEn())}
                    value={params.name.en}
                    errors={validationErrors['name.en']}
                    onChange={en => {
                      setParams({
                        ...params,
                        name: {
                          ...params.name,
                          en: en,
                        },
                      });
                    }}
                  />
                </div>
              </div>
            )}
            <div className="my-3">
              {!!errorMessage && <Alert color="danger">{errorMessage}</Alert>}
              {!!updateErrorMessage && (
                <Alert color="danger">{updateErrorMessage}</Alert>
              )}
            </div>
          </Row>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="important"
          onClick={store ? submit : updateSubmit}
          isLoading={store ? isLoading : updateIsLoading}
        >
          {t(...messages.yesImSure())}
        </Button>
        <Button color="secondary" onClick={onDismiss}>
          {t(...messages.cancel())}
        </Button>
      </ModalFooter>
    </Fragment>
  );
};

export default MaterialModal;
